import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { fetchActualizarCategoriaPublicacion, fetchObtenerCategoriaPublicacion } from '../../../peticiones_API/PeticionesCategoriasPublicaciones';
import { handleSubmitErrors, handleChangeErrors, todosDatosCorrectos } from '../../validacion/ValidationFormCategoria';
import { DatosCorrectos, CategoriaPublicacionExistente, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";
import { FaFile} from "react-icons/fa6";
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Col from 'react-bootstrap/Col';

const FormEditarCategoriaPublicacion = ({ usuarioLogueado }) => {

    const { Id } = useParams();
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({categoria: '', descripcion: ''});

    const camposRequeridos = {
            categoria: "Debes insertar una categoría nueva",
    };
    
    const [estadoCampoReque, setEstadoCampoReque] = useState({
        categoria: null,
    });
    
    let [formCompletado, setFormCompletado] = useState(null);

    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [enviado, setEnviado] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        categoriaDuplicada: null,
    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setEstadosActualizados(false);
        setEnviado(true);

        handleSubmitErrors(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    useEffect(() => {
        async function fechtPrincipal() {
            try {
                if (!usuarioLogueado?.id) {
                    return;
                }

                const categoriasPublicaciones = await fetchObtenerCategoriaPublicacion(Id);
                console.log("listado", categoriasPublicaciones);

                setFormData(prevFormData => ({
                    ...prevFormData,
                    Id: categoriasPublicaciones.Id,
                    categoria: categoriasPublicaciones.categoria,   
                    descripcion: categoriasPublicaciones.descripcion         
                }));

                const campos = [
                    'categoria'
                ];

                campos.forEach(campo => {
                    if (categoriasPublicaciones[campo] != null) {
                        setEstadoCampoReque(prevState => ({
                            ...prevState,
                            [campo]: false
                        }));
                    }
                });

                setLoading(false);
            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, [Id, usuarioLogueado?.id]);


    useEffect(() => {  

        if (estadosActualizados && enviado) {
            console.log("formData", formData);
            console.log("estadoCampoReque", estadoCampoReque);

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();

            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    console.log("Simulacion editar CategoríaPublicación");

                    try {
                        const datosParaEnviar = {
                            ...formData
                        };

                        const response = await fetchActualizarCategoriaPublicacion(formData.Id, datosParaEnviar); 
                        console.log("Publicación editada:", response);

                    } catch (error) {
                        console.log(error?.response?.data?.error);

                        setFormCompletado(false);

                        if (error?.response?.data?.error === 'categoria existe') {

                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, categoriaDuplicada: true }));
                        }


                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
                setEnviado(false);
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque, enviado]);

    const handleChange = (event) => {
        setErrorEnviarForm({ publicacionDuplicada: false });

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const { name, value} = event.target;

        let newValue;

        newValue = value;

        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));

        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }

    };

    if(loading) return <div>Cargando...</div>;

    console.log("formData", formData);

    return (
        <>
                <Form >
                    <CabeceraForm>
                        <Titulo
                            texto="EDITAR CATEGORÍA"
                        />
                        <Boton
                        grande="true"
                        as="button"
                        primario="true"
                        type="submit"
                        onClick={handleSubmit}
                        form="true"
                        bonificados="true"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                        >
                            Guardar y Salir{<FaFile style={{marginLeft:'8px'}}/>}
                        </Boton>

                    </CabeceraForm>

                    <Col md={{ span: 10, offset: 1 }}>{/*span:10 */}
                        <ToastContainer />

                        <InputContainer style={{width:'100%'}} >
                            <LabelBorde hasValue={!!formData.categoria}>Título de la categoría</LabelBorde>
                            <InputBorde
                                type="text"
                                name="categoria"
                                value={formData.categoria || ''}
                                onChange={handleChange}
                            />
                        </InputContainer>

                        <InputContainer style={{alignItems:'start'}}>
                            <LabelBorde style={{transform:'translateY(-8px)'}} hasValue={!!formData.descripcion}>Descripción de la categoría</LabelBorde>
                            <TextAreaa
                            name="descripcion"
                            value={formData.descripcion || ''}
                            onChange={handleChange}
                            ></TextAreaa>
                        </InputContainer>


                        <ContenedorBotones>

                            <Boton
                            grande="true"
                            as="button"
                            primario="true"
                            type="submit"
                            onClick={handleSubmit}
                            form="true"
                            bonificados="true"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                            name="guardar_cambios_statico"
                            >
                                Guardar{<FaFile style={{marginLeft:'8px'}}/>}
                            </Boton>

                            <Boton
                                grande="true"
                                to="/comunicacion/categorias"
                                bonificados="true"
                            >
                                Cancelar
                            </Boton>
                        </ContenedorBotones>

                    </Col>

                </Form>

                {botonRenderClick ? 
                    <DatosCorrectos envioActivado={formCompletado} />         
                    :             
                    <DatosCorrectos envioActivado={formCompletado} redirect={false} />
                }
                
            <DatosIncorrectos envioActivado={formCompletado} />
            <CategoriaPublicacionExistente envioActivado={errorEnviarForm.categoriaDuplicada} />
        </>

    )
}

const CabeceraForm = styled.div`
    display:flex;
    margin-left:10%;
    width: 80%;
    justify-content:space-between;
    align-items:center;
    margin-bottom: 2%;
`

export const InputContainer = styled(Form.Group)`
  position: relative;
  margin-top: 1.5rem;
  display:flex;
  justify-content:start;
  align-items:center;

   &:focus {
    box-shadow: none;
  }
`;

export const LabelBorde = styled.label`
  position: absolute;
  z-index: 5;
  background: white;
  font-size: 16px;
  margin-left: 12px;
  color: #9b9a9a !important;
  font-weight: 500;
  padding: 0 4px;
  pointer-events: none;
  transition: all 0.2s ease;


  //Cuando el input está en foco 
  ${InputContainer}:focus-within & {
    transform: translateY(-20px);
    font-size: 12px;
    color: #2587d8;
  }

  //Cuando tiene valor
  ${({ hasValue }) =>
    hasValue &&
    `
      transform: translateY(-20px);
      font-size: 12px;
      color: #868383;
    `}

    ${({ fechaValue }) =>
    fechaValue  &&
    `
      transform: translateY(-20px);
      font-size: 12px;
      color: #868383;
    `}
`;

export const InputBorde = styled(Form.Control)`
  padding: 10px;
  border: 1px solid #b3acac !important;
  box-shadow: none;

  &:focus,
  &:focus-visible {
    border: 1px solid #000;
    box-shadow: none !important;
    outline: none !important;
  }

  &:hover{
    border: 1px solid #000 !important;
  }
`;

export const TextAreaa = styled.textarea `
    width: 100%;
    height: 250px;
    border: 1px solid #b3acac !important;
    margin-top: 10px;
`;

const ContenedorBotones = styled.div`
    margin-top: 4%;
    display: flex;
    justify-content: center;
    gap: 10px; 

    @media screen and (max-width: 800px) {
       margin-top: 10%; 
    }
`

export default FormEditarCategoriaPublicacion;